module.exports = "/public/images/9e8546b0eebcac97bac767c772086a36.png";